export enum ImacTypesEnum {
  silver = 'silver',
  golden = 'golden',
}
